import { enMerged } from './en';
import { zh } from './zh';
import VueI18n from 'vue-i18n';
import Vue from 'vue';
import { Lang } from '@/i18n/lang';
import { CustomFormatter } from '@/i18n/formatter';
const zhWithDefault = Object.keys(zh).length
    ? zh
    : Object.assign({}, Object.keys(enMerged).reduce((obj, key) => {
        Object.assign(obj, { [key]: key });
        return obj;
    }, {}), zh);
const messages = {
    [Lang.English]: { ...enMerged },
    [Lang.Chinese]: { ...zhWithDefault },
};
export const i18nOptions = {
    locale: window.langController.getLang(),
    fallbackLocale: Lang.Chinese,
    messages,
    silentTranslationWarn: true,
    formatter: new CustomFormatter(),
};
Vue.use(VueI18n);
export const i18n = new VueI18n(i18nOptions);
export const $t = (...args) => i18n.t(...args);
Vue.prototype.$t = $t;
